<template>
  <div
    v-if="fetcher"
    class="text-center py-[16px]"
  >
    <div
      v-if="fetcher.isLoading && fetcher.data.length > 0"
      ref="loadingFooter"
      class="d-flex justify-content-center align-items-center"
    >
      <b-spinner
        variant="primary"
        label="Loading..."
      />
      <span class="ml-[8px]">Memuat data...</span>
    </div>
    <div
      v-else-if="fetcher.hasMore"
      ref="intersectionFooter"
    />
    <div
      v-else-if="fetcher.data && fetcher.data.length > 0"
      class="text-muted py-2"
    >
      Semua data telah dimuat
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fetcher: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      observer: null,
    }
  },
  mounted() {
    this.setupIntersectionObserver()
    this.observeFooter()
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  updated() {
    // Re-observe footer when it changes
    this.observeFooter()
  },
  methods: {
    setupIntersectionObserver() {
      if (!this.observer) {
        this.observer = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              if (
                entry.isIntersecting
                && this.fetcher
                && this.fetcher.hasMore
                && !this.fetcher.isLoading
              ) {
                this.fetcher.fetchData()
              }
            })
          },
          {
            root: null,
            rootMargin: '0px',
            threshold: 0.1,
          },
        )
      }
      this.observeFooter()
    },
    observeFooter() {
      if (!this.observer) return

      // Disconnect all current observations
      this.observer.disconnect()

      // Re-observe the footer element when it's available
      this.$nextTick(() => {
        const footerElement = this.$refs.intersectionFooter
        if (footerElement && this.fetcher && this.fetcher.hasMore) {
          this.observer.observe(footerElement)
        }
      })
    },
  },
}
</script>
